import React from "react"
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    Box,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TableContainer,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@mui/material"
import { toaster, Message } from "rsuite"
import PropTypes from "prop-types"
import { makeStyles } from "@mui/styles"
import {
    ExpandMoreOutlined,
    Add,
    UploadFileOutlined
} from "@mui/icons-material"
import ImportTimetableDialog from "./ImportTimetableDialog"
import {
    resetForm,
    updateFields,
    // resetForm
} from "../Redux/actions/formValue.action"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"

export default function ExamList({
    examList = [],
    handleCreateTimetable,
    handleFetchAllExamTimetable,
    allTimetableList = [],
    setExamObj,
    addSubjectIntoTimetable,
    classList = []
}) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [accordionId, setAccordionId] = React.useState(null)
    const [accordionName,setAccordionName] = React.useState(null)
    const [importExam, setImportExam] = React.useState(null)

    const state = useSelector((state) => state.form)

    React.useEffect(()=> {
        if(allTimetableList.length > 0){
            const findTimetable = _.get(allTimetableList[0],"exam_timetable",[])
            dispatch(updateFields({collection:findTimetable}))
        }else{
            dispatch(updateFields({collection:[]}))
        }
    },[allTimetableList])


    if (!examList || examList.length === 0) return null

    let subjectName = _.get(state, "state.subject", "")
    let date = _.get(state, "state.date", "")
    let start = _.get(state, "state.start", "")
    let end = _.get(state, "state.end", "")
    let endDisplay = _.get(state,"state.endDisplay","")
    let startDisplay = _.get(state,"state.startDisplay","")
    let collection = _.get(state, "state.collection", [])


    return (
        <div className="col-md-12">
            {
                examList.map((exam, index) => {
                    let className = Array.isArray(classList) && classList.length > 0 && classList.find(cl => cl.id === exam.class_ref)
                    let minorSubjects = className && _.get(className,"meta_data.minorSubjects",[])
                    let subjects = className && _.get(className,"meta_data.subjects",[])
                    return (
                        <Accordion
                            key={index}
                            onChange={() => {
                                if (exam.exam_name === accordionName && exam.class_ref === accordionId) {
                                    setAccordionId(null)
                                    setAccordionName(null)
                                } else {
                                    setAccordionName(exam.exam_name)
                                    setAccordionId(exam.class_ref)
                                    const {
                                        class_ref,
                                        school_ref,
                                        exam_name
                                    } = exam
                                    handleFetchAllExamTimetable(class_ref, school_ref)
                                    setExamObj({
                                        exam
                                    })
                                    dispatch(resetForm())
                                }
                            }}
                            expanded={exam.exam_name === accordionName && exam.class_ref === accordionId}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreOutlined />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography classes={{
                                    root: classes.examLabel
                                }}>
                                    {className?.class_name} (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        justifyContent:"center",
                                        alignItems:"center"
                                    }}>
                                        <span style={{
                                            fontFamily: "Lato",
                                            fontWeight: 200,
                                            fontSize: "14px",
                                            textAlign:"center",
                                            borderBottom:"1px solid red"
                                        }}>{exam.exam_name}</span>
                                        <span style={{
                                            fontFamily: "Lato",
                                            fontWeight: 200,
                                            fontSize: "10px",
                                        }}>{`Created At - ${exam.created_at}`}</span>
                                        <span style={{
                                            fontFamily: "Lato",
                                            fontWeight: 200,
                                            fontSize: "10px"
                                        }}>{`Updated At - ${exam.updated_at}`}</span>
                                    </div> )
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails classes={{
                                root: classes.accordionSummary
                            }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                    <Typography sx={{ fontSize: 13, color: "#64748b" }}>
                                        Add subjects one by one below, or import the whole timetable from a file.
                                    </Typography>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        startIcon={<UploadFileOutlined />}
                                        onClick={() => setImportExam({ exam, className: className?.class_name || "" })}
                                        sx={{ textTransform: "none", fontWeight: 600 }}
                                    >
                                        Import from file
                                    </Button>
                                </Box>
                                {
                                    Array.isArray(collection) && collection.length > 0 && (
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead classes={{
                                                    root: classes.tableHeader
                                                }}>
                                                    <TableRow>
                                                        <TableCell classes={{
                                                            root: classes.textHeader
                                                        }}>SL_NO</TableCell>
                                                        <TableCell classes={{
                                                            root: classes.textHeader
                                                        }}>Subject</TableCell>
                                                        <TableCell classes={{
                                                            root: classes.textHeader
                                                        }}>Date</TableCell>
                                                        <TableCell classes={{
                                                            root: classes.textHeader
                                                        }}>Start Time</TableCell>
                                                        <TableCell classes={{
                                                            root: classes.textHeader
                                                        }}>End Time</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        collection.map((item, index) => {
                                                            return (
                                                                <TableRow
                                                                    key={item.subject}
                                                                >
                                                                    <TableCell classes={{
                                                                        root: classes.textRows
                                                                    }}>{index + 1}</TableCell>
                                                                    <TableCell classes={{
                                                                        root: classes.textRows
                                                                    }}>{item.subject}</TableCell>
                                                                    <TableCell classes={{
                                                                        root: classes.textRows
                                                                    }}>{item.date}</TableCell>
                                                                    <TableCell classes={{
                                                                        root: classes.textRows
                                                                    }}>{item.start}</TableCell>
                                                                    <TableCell classes={{
                                                                        root: classes.textRows
                                                                    }}>{item.end}</TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )
                                }
                                <Box
                                    key={index}
                                    sx={{
                                        display: "grid",
                                        gap: 2,
                                        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 1fr 1fr 80px" },
                                        mb: 2,
                                    }}
                                >
                                    {
                                        Array.isArray(subjects) && subjects.length > 0 ? (
                                            <FormControl>
                                                <InputLabel>Select Subject</InputLabel>
                                                <Select
                                                    variant="outlined"
                                                    label={"Select Subject"}
                                                    value={subjectName}
                                                    onChange={(e) => {
                                                        let val = e.target.value
                                                        dispatch(updateFields({ subject: val.toUpperCase() }))
                                                    }}
                                                    size="small"
                                                >
                                                    {
                                                        Array.isArray(subjects) && subjects.length > 0 && subjects.map((sub) => {
                                                            // Subjects are saved as { subject_name, teachers }
                                                            const name = (sub?.subject_name || sub?.name || "").toUpperCase()
                                                            return (
                                                                <MenuItem
                                                                    key={name}
                                                                    value={name}
                                                                >
                                                                    {name}
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                    {/* {
                                                        Array.isArray(minorSubjects) && minorSubjects.length > 0 && minorSubjects.map((sub) => {
                                                            return (
                                                                <MenuItem
                                                                    key={sub?.name}
                                                                    value={sub.name}
                                                                >
                                                                    {sub.name}
                                                                </MenuItem>
                                                            )
                                                        })
                                                    } */}
                                                </Select>
                                            </FormControl>
                                        ) : (
                                            <TextField
                                                fullWidth
                                                label="Subject Name"
                                                focused
                                                size="small"
                                                value={subjectName}
                                                onChange={(e) => {
                                                    let val = e.target.value
                                                    dispatch(updateFields({ subject: val.toUpperCase() }))
                                                }}
                                            />
                                        )
                                    }
                                    <TextField
                                        type="date"
                                        fullWidth
                                        label="Date"
                                        InputLabelProps={{ shrink: true }}
                                        focused
                                        size="small"
                                        value={date}
                                        onChange={(e) => {
                                            let val = e.target.value
                                            dispatch(updateFields({ date: val }))
                                        }}
                                    />
                                    <TextField
                                        type="time"
                                        fullWidth
                                        label="Start Time"
                                        InputLabelProps={{ shrink: true }}
                                        focused
                                        size="small"
                                        value={start ? start.split(" ")[0] : ""}
                                        onChange={(e) => {
                                            let val = e.target.value
                                            const [hours, minutes] = val.split(":")
                                            const hourNum = parseInt(hours, 10)
                                            const amPm = hourNum >= 12 ? "PM" : "AM"
                                            const displayHour = hourNum % 12 || 12
                                            const formattedTime = `${displayHour}:${minutes} ${amPm}`
                                            
                                            dispatch(updateFields({ start: val }))
                                            dispatch(updateFields({startDisplay:formattedTime}))
                                        }}
                                    />
                                    <TextField
                                        type="time"
                                        fullWidth label="End Time"
                                        InputLabelProps={{ shrink: true }}
                                        focused
                                        size="small"
                                        value={end}
                                        onChange={(e) => {
                                            let val = e.target.value
                                            const [hours, minutes] = val.split(":")
                                            const hourNum = parseInt(hours, 10)
                                            const amPm = hourNum >= 12 ? "PM" : "AM"
                                            const displayHour = hourNum % 12 || 12
                                            const formattedTime = `${displayHour}:${minutes} ${amPm}`
                                            dispatch(updateFields({ end: val }))
                                            dispatch(updateFields({endDisplay:formattedTime}))
                                        }}
                                    />
                                    <Button
                                        startIcon={<Add />}
                                        size="small"
                                        variant="outlined"
                                        onClick={() => {
                                            if (!startDisplay || !endDisplay || !date || !subjectName) {
                                                toaster.push(<Message type="info">Fill All the fields details</Message>, { placement: "topCenter" })
                                                return
                                            }
                                            const data = {
                                                subject: subjectName,
                                                date,
                                                start:startDisplay,
                                                end:endDisplay
                                            }
                                            if (collection && collection.length > 0) {
                                                let isExistSubject = collection.find(i => i.subject === subjectName)
                                                if (isExistSubject) {
                                                    toaster.push(<Message type="info">Subject already added</Message>, { placement: "topCenter" })
                                                    return
                                                }
                                            }
                                            dispatch(updateFields({subject:""}))
                                            dispatch(updateFields({date:""}))
                                            dispatch(updateFields({start:""}))
                                            dispatch(updateFields({end:""}))
                                            dispatch(updateFields({endDisplay:""}))
                                            dispatch(updateFields({startDisplay:""}))
                                            dispatch(updateFields({ collection: [...collection, data] }))
                                        }}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        fullWidth
                                        onClick={() => {
                                            let data = {
                                                exam_id: exam.id,
                                                exam_timetable: [...collection]
                                            }
                                            if(allTimetableList.length === 0){
                                                handleCreateTimetable(data)
                                            }else if(allTimetableList.length > 0){
                                                addSubjectIntoTimetable(allTimetableList[0].id, exam.id, collection)
                                            }
                                            dispatch(updateFields({collection:[]}))
                                        }}
                                    > {allTimetableList.length > 0 ? "Update" : "Submit"}</Button>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                })
            }
            {
                importExam && (
                    <ImportTimetableDialog
                        exam={importExam.exam}
                        className={importExam.className}
                        onClose={() => setImportExam(null)}
                        onImported={() => {
                            const { class_ref, school_ref } = importExam.exam
                            handleFetchAllExamTimetable(class_ref, school_ref)
                        }}
                    />
                )
            }
        </div>
    )
}

ExamList.propTypes = {
    examList: PropTypes.array,
    handleCreateTimetable: PropTypes.func,
    handleFetchAllExamTimetable: PropTypes.func,
    allTimetableList: PropTypes.array,
    setExamObj:PropTypes.func,
    addSubjectIntoTimetable:PropTypes.func,
    classList:PropTypes.array
}

const useStyles = makeStyles({
    root: {

    },
    examLabel: {
        fontFamily: "Lato",
        fontWeight: "bold",
        textTransform: "uppercase",
        lineHeight: "12px",
        fontSize: "18px",
        color: "#442b2bff",
        display: "flex",
        flexDirection: "row",
        gap: "4px",
        justifyContent: "center",
        alignItems: "center"
    },
    accordionSummary: {
        display: "flex",
        flexDirection: "column",
        columnGap: "8px",
        gap: "18px"
    },
    tableHeader: {
        backgroundColor: "pink"
    },
    textHeader: {
        padding: 0,
        fontFamily: "Lato",
        fontSize: "14px",
        textAlign: "center",
        fontWeight: "bold"
    },
    textRows: {
        fontFamily: "Lato",
        fontSize: "14px",
        padding: 0,
        fontStyle: "italic",
        textAlign: "center"
    }
})